<template>
    <table class="table table-condensed table-detailed">
        <thead>
            <tr>
                <th>ID</th>
                <th>Nom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <!-- <th class="text-center">Actif</th> -->
            </tr>
        </thead>

        <tbody>
            <template v-for="user in users">
                <user-row-item :key="'user-item-' + user.id"
                    :user="user"
                    :is-selected="user.id == selectedUserId"
                    @row-clicked="onRowClick"></user-row-item>

                <user-row-detail :key="'user-detail-' + user.id"
                    :user="user"
                    @name-updated="onUserNameUpdate"
                    @phone-updated="onUserPhoneUpdate"
                    @email-updated="onUserEmailUpdate"
                    v-if="user.id == selectedUserId"></user-row-detail>
            </template>
        </tbody>
    </table>
</template>

<script>
    import UserRowItem from './UserRowItem'
    import UserRowDetail from './UserRowDetail'

    export default {
        data() {
            return {
                selectedUserId: null
            }
        },

        props: {
            users: {
                type: Array,
                required: true
            }
        },

        components: {
            UserRowItem,
            UserRowDetail
        },

        methods: {
            onRowClick(userId) {
                this.selectedUserId = userId == this.selectedUserId ? null : userId
            },

            onUserNameUpdate(userIdObject) {
                this.$emit('user-name-updated', userIdObject)
            },

            onUserPhoneUpdate(userIdObject) {
                this.$emit('user-phone-updated', userIdObject)
            },
            
            onUserEmailUpdate(userIdObject) {
                this.$emit('user-email-updated', userIdObject)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Users/UsersTable.vue